import React, {useState} from 'react';
import {useTranslation} from "react-i18next";
import {useFormik} from "formik";
import moment from "moment/moment";
import * as Yup from "yup";
import {Container, Row, Col} from "react-bootstrap";
import Target from "../../../ui/components/Target/Target";
import cl from './CertificateForm.module.css';
import {Query} from "@syncfusion/ej2-data";
import DropDownList from "../../../ui/components/DropDownList/DropDownList";
import Input from "../../../ui/components/Input/Input";



const CertificateForm = ({
                      id,
                      createdOn,
                      name,
                      serviceWorkId,
                      isBlocked,
                      targets,
                      onSubmit
                  }) => {
    const [postCategoryQuery] = useState(new Query().addParams('isBlocked', 'active').addParams('name', '0'));

    const {t} = useTranslation();

    const form = useFormik({
        enableReinitialize: true,
        initialValues: {
            id: id,
            createdOn: createdOn !== null ? moment.utc(createdOn).toDate() : null,
            isBlocked: isBlocked,
            serviceWorkId: serviceWorkId,
            name: name,
            targets: targets
        },
        validationSchema: Yup.object({
            name: Yup.string()
                .required(t("errors.required-error")),
            serviceWorkId: Yup.string()
                .required(t("errors.required-error")),
        }),
        onSubmit: onSubmit
    });

    return (
        <Container fluid>
            <form id='page-form' onSubmit={form.handleSubmit}>
                <Row>
                    <Row className={cl.formRow}>
                        <Col>
                            <div className='input-container syncfusion-control-input-container'>
                                <label className='label required'>
                                    {t("certificate.form.name")}
                                </label>
                                <Input name='name'
                                       type='text'
                                       placeholder={t("certificate.form.name")}
                                       disabled={form.isSubmitting}
                                       onChange={form.handleChange}
                                       autoComplete='off'
                                       value={form.values.name}/>
                            </div>
                        </Col>

                    </Row>
                    <Col className={cl.checkboxesContainer}>
                        <div className='input-container checkbox'>
                            <label className='label'>
                                {t("certificate.form.blocked")}
                            </label>
                            <Input name='isBlocked'
                                   type='checkbox'
                                   disabled={form.isSubmitting}
                                   onChange={form.handleChange}
                                   checked={form.values.isBlocked}/>
                        </div>

                    </Col>
                </Row>
                <Row className={cl.formRow}>
                    <Col>
                        <div className='input-container syncfusion-control-input-container'>
                            <label className='label required'>
                                {t("certificate.form.serviceWork")}
                            </label>
                            <Input name='serviceWorkId'
                                   type='text'
                                   placeholder={t("certificate.form.serviceWork")}
                                   disabled={form.isSubmitting}
                                   onChange={form.handleChange}
                                   autoComplete='off'
                                   value={form.values.serviceWorkId}/>
                        </div>
                    </Col>

                </Row>


            </form>
            <Row className={cl.formRow}>

                <Col>
                    <Target targets={form.values.targets}
                            disabled={form.isSubmitting}
                            change={(items) => form.setFieldValue('targets', items)}/>
                </Col>
            </Row>
        </Container>
    );
};

export default CertificateForm;
